import Decimal from "decimal.js";
import { flow } from "lodash-es";
import { isStringNotBlank } from "shared/utils/StringUtils";

export const makeInputTransforms = (
  valueAsNumber: boolean,
  isPercent: boolean,
  allowBlank: boolean = false,
) => ({
  transformInput: flow(
    (value: string | number) =>
      valueAsNumber ? value.toString() : (value as string),
    (value) =>
      isPercent && (isStringNotBlank(value) || !allowBlank)
        ? new Decimal(value || "0").mul(100).valueOf()
        : value,
  ),
  transformOutput: flow(
    (value: string) =>
      isPercent ? new Decimal(value || "0").div(100).valueOf() : value,
    (value) => (valueAsNumber ? Number(value) : value),
  ),
});
